export default (url: string) => {
  if (/^(https?:\/\/)?([a-z0-9-]+\.)+[a-z]{2,}(\/.*)?$/i.test(url.trim())) return undefined;
  return 'Invalid url';
};
